module.exports = __webpack_public_path__ + "img/people-icon.0d188cd5.svg";